import { render } from "./PricesComponent.vue?vue&type=template&id=409c5108&scoped=true"
import script from "./PricesComponent.vue?vue&type=script&lang=js"
export * from "./PricesComponent.vue?vue&type=script&lang=js"

import "./PricesComponent.vue?vue&type=style&index=0&id=409c5108&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-409c5108"]])

export default __exports__